import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';

import { PlaceListDataService } from 'src/app/general/places/list/place-list.data';
import { AirportEditorView } from './airport-editor.view';

interface AirportEditorControllerProps {
    value: number | null;
    mode: ControlMode;
    onChanged: (value: number | null) => void;
    setBusy(isBusy: boolean);
    label?: string;
    required?: boolean;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class AirportEditorController extends React.Component<AirportEditorControllerProps, any> {
    protected airportDataService: PlaceListDataService;

    constructor(props) {
        super(props);
        this.airportDataService = PlaceListDataService.make();
    }

    @autobind
    protected airportQuery(q?: string): Promise<QueryResult<PlaceSummary>> {
        return new Promise<QueryResult<PlaceSummary>>((resolve, reject) => {
            this.props.setBusy(true);
            this.airportDataService.addFilter('type', 'eq', 1);
            this.airportDataService.addFilter('isDeleted', 'eq', false);
            this.airportDataService.addSorting('id', 'asc', true);
            this.airportDataService.searchKeywords = q;
            this.airportDataService.load(query => query)
                .then((items) => {
                    this.props.setBusy(false);
                    resolve({
                        items: items,
                        totalCount: this.airportDataService.count
                    });
                });
        });
    }

    render() {
        return (
            <AirportEditorView
                airportRequest={{ query: this.airportQuery, dataSet: this.airportDataService }}
                onChanged={this.props.onChanged}
                value={this.props.value}
                onGetErrorMessage={this.props.onGetErrorMessage}
                mode={this.props.mode}
                label={this.props.label}
                required={this.props.required}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/airports/parts/airport-editor.controller.tsx